import { render, staticRenderFns } from "./DeliverRestrictions.vue?vue&type=template&id=67eda598&scoped=true&"
import script from "./DeliverRestrictions.vue?vue&type=script&lang=js&"
export * from "./DeliverRestrictions.vue?vue&type=script&lang=js&"
import style0 from "./DeliverRestrictions.vue?vue&type=style&index=0&id=67eda598&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eda598",
  null
  
)

export default component.exports